document.addEventListener("DOMContentLoaded", () => {
	var maxFileSize = 2 * 1024 * 1024; // (байт) Максимальный размер файла (2мб)
	var queue = {};
	var imagesList = $('#uploadImagesList');

	var itemPreviewTemplate = imagesList.find('.item.template').clone();
	itemPreviewTemplate.removeClass('template');
	imagesList.find('.item.template').remove();

	// document.querySelector

	$('.upload-img input[type="file"]').each(function(){

		$(this).on('change', function () {

			var files = this.files;
			var el = $(this);

			// removeBase64Photos(el.next('#uploadImagesList'));
		
			for (var i = 0; i < files.length; i++) {
				var file = files[i];
		
				if ( !file.type.match(/image\/(jpeg|jpg|png|gif)/) ) {
					alert( 'Фотография должна быть в формате jpg, png или gif' );

					this.value = '';

					removeBase64Photos(el.next('#uploadImagesList'));
					break;
				}
		
				if ( file.size > maxFileSize ) {
					alert( 'Размер фотографии не должен превышать 2 Мб' );

					this.value = '';

					removeBase64Photos(el.next('#uploadImagesList'));
					break;
				}
		
				// preview(files[i]);
				// Создание превью
				var reader = new FileReader();

				;(function(file){
					reader.addEventListener('load', function(event) {

						// var img = document.createElement('img');
	
						var itemPreview = itemPreviewTemplate.clone();
	
						let img = itemPreview.find('.img-wrap img');
	
	
						img.attr("name", file.name);
	
						img.attr('src', event.target.result);
	
						itemPreview.data('id', file.name);
	
						el.next('#uploadImagesList').append(itemPreview);
	
						queue[file.name] = file;
	
					});
					reader.readAsDataURL(file);
				})(file);
			}
		});
	});
		
		

	// Удаление фотографий
	$('body').on('click', '.delete-link', function () {

		const item = $(this).closest('.item'),
			id = item.data('id'),
			$parentDiv = $(this).closest(".upload-img"),
			inputFileID = $parentDiv.find("input[type=file]").attr("id"),
			$targetImg = item.find("img");

		let $targetInput = $parentDiv.find("input[type='hidden'].removedPhotos");

		if ($targetInput.length == 0){
			$parentDiv.append(`<input type='hidden' name='removed-files-${inputFileID}' value='[]' class='removedPhotos'>`);

			$targetInput = $parentDiv.find(".removedPhotos");
		}

		let removedPhotosArray = JSON.parse($targetInput.val());

		delete queue[id];

		removedPhotosArray.push($targetImg.attr("name") || $targetImg.attr("id"));

		$targetInput.val(JSON.stringify(removedPhotosArray));

		item.remove();
	});

})

function removeBase64Photos($container){
	$removePhotosInput = $container.closest(".upload-img").find(".removedPhotos");

	let removePhotosArray = $removePhotosInput.length ? JSON.parse($removePhotosInput.val()) : [];

	$container.find("img[src*='data:image']").each(function(){
		const currentName = $(this).attr("name");

		removePhotosArray.splice(removePhotosArray.indexOf(currentName), 1);

		$(this).closest(".item").remove();
	});

	$removePhotosInput.val(JSON.stringify(removePhotosArray));
}


// WEBPACK FOOTER //
// ./src/js/img.upload.js